<div class="login-page">
  <div class="login-wrapper">

    <!-- Brand Panel -->
    <div class="brand-panel d-none d-md-flex">
      <div class="brand-content">
        <div class="brand-logo-wrap">
          <img src="assets/img/favicon.png" alt="Logo LC" class="brand-logo" />
        </div>
        <h2 class="brand-title">LC All In One</h2>
        <p class="brand-subtitle">LC Kampung Inggris</p>
        <p class="brand-desc">Online Administration System</p>
        <div class="brand-badge">
          <span>Core System v2</span>
        </div>
      </div>
    </div>

    <!-- Form Panel -->
    <div class="form-panel">
      <div class="login-card">

        <!-- Mobile logo -->
        <div class="mobile-brand d-flex d-md-none">
          <div class="mobile-logo-wrap">
            <img src="assets/img/favicon.png" alt="Logo LC" class="mobile-logo" />
          </div>
        </div>

        <div class="form-header">
          <h1 class="form-title">Selamat Datang</h1>
          <p class="form-subtitle">Masuk ke akun Anda untuk melanjutkan</p>
        </div>

        <form #loginForm="ngForm" (ngSubmit)="login()">

          <!-- Username -->
          <div class="field-group">
            <label class="field-label" for="username">Username</label>
            <div class="input-wrapper">
              <span class="input-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </span>
              <input
                id="username"
                type="text"
                class="field-input"
                placeholder="Masukkan username"
                name="username"
                [(ngModel)]="user.username"
                required
                autocomplete="off"
                autofocus
              />
            </div>
          </div>

          <!-- Password -->
          <div class="field-group">
            <label class="field-label" for="password">Password</label>
            <div class="input-wrapper">
              <span class="input-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </span>
              <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                class="field-input field-input--icon-right"
                placeholder="Masukkan password"
                name="password"
                [(ngModel)]="user.password"
                required
                autocomplete="off"
              />
              <button type="button" class="input-toggle" (click)="showPassword = !showPassword">
                <svg *ngIf="!showPassword" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="showPassword" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Submit -->
          <button
            type="submit"
            class="btn-login"
            [disabled]="!loginForm.form.valid || isLoading"
          >
            <ng-container *ngIf="!isLoading">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                <polyline points="10 17 15 12 10 7"/>
                <line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
              Masuk
            </ng-container>
            <ng-container *ngIf="isLoading">
              <svg class="spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
              </svg>
              Memproses...
            </ng-container>
          </button>

        </form>

        <p class="footer-text">© {{ currentYear }} LC Kampung Inggris. All rights reserved.</p>
      </div>
    </div>

  </div>
</div>
